import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["container-fluid", _ctx.containerClass])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["row justify-content-center", _ctx.rowClass])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.colClass)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2)
    ], 2)
  ]))
}